module.exports = __webpack_public_path__ + "img/logo-enel.a7cabc99.png";